export const getIsSixteenByNineAspectRatio = (camera) =>
  camera?.aspectRatio === '16x9';
